import { initCacheInvalidatorRegister } from '../cacheRegisterConstructor';

export enum AnalyticsSyncCacheEvents {
  CREATE = 'CREATE',
  DELETE = 'DELETE',
}

interface CacheParams {
  organizationId: string;
}

const cacheRegister = initCacheInvalidatorRegister<
  typeof AnalyticsSyncCacheEvents,
  CacheParams
>(AnalyticsSyncCacheEvents);

export const invalidateAnalyticsSyncCache = cacheRegister.invalidate;
export const analyticsSyncCacheRegister = cacheRegister.register;
